<template>
  <v-container class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card
          style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
        >
          <v-card-text>
            <!-- State 1: No resolution data at all -->
            <v-alert
              v-if="!hasAnyResolutionData && !editMode"
              :value="true"
              outline
              color="success"
              icon="mdi-check-circle"
              class="font-weight-bold"
            >
              No resolution has been submitted for this ticket.
            </v-alert>

            <!-- State 2 & 3: Has resolution data -->
            <div v-else>
              <div v-if="!editMode">
                <div class="mb-0">
                  <v-layout row wrap>
                    <v-flex xs12 class="mb-0">
                      <span class="font-weight-medium">By: </span>
                      <span>{{ ticket.resolutionSubmittedByName }}</span>
                      <span class="font-weight-medium"> On: </span>
                      <span>{{ ticket.resolutionSubmittedOn | time }}</span>
                    </v-flex>
                  </v-layout>
                  <v-divider class="mt-0 mb-3"></v-divider>
                </div>

                <!-- Resolution content -->
                <div
                  contenteditable="false"
                  v-html="ticket.resolutionContent"
                ></div>
              </div>
              <div
                v-else
                class="mt-2"
                rows="5"
                style="width: 100%; min-height: 120px; padding: 10px; border: 2px solid #ccc; border-radius: 4px;"
                v-html="ticket.resolutionContent"
                @input="updateResolutionContent"
                contenteditable="true"
              ></div>
            </div>
          </v-card-text>
          <v-card-actions class="pb-3 pt-0">
            <v-spacer></v-spacer>
            <div v-if="!editMode">
              <v-btn small color="success" @click="enterEditMode">Edit</v-btn>
            </div>
            <div v-else>
              <v-btn
                color="default"
                small
                @click="editMode = false"
                :dark="true"
                :disabled="false"
                >Cancel</v-btn
              >
              <v-btn
                small
                :loading="processing"
                color="success"
                @click="saveChanges"
                >Save Changes</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { linkifyPlainUrlsInHtml } from "./helpDeskHelpers.js";

export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      editMode: false,
      processing: false,
      edit: {
        resolutionContent: "",
      },
    };
  },
  computed: {
    ticket() {
      return (this.initialData && this.initialData.ticket) || {};
    },
    hasAnyResolutionData() {
      return !!this.ticket.resolutionContent;
    },
  },
  methods: {
    enterEditMode() {
      this.editMode = true;
    },

    async saveChanges() {
      if (
        this.edit.resolutionContent === this.ticket.resolutionContent ||
        this.edit.resolutionContent === ""
      ) {
        return this.$notify({
          group: "notification",
          text: "No changes detected",
          type: "info",
        });
      }
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = this.edit.resolutionContent;
      if (!tempDiv.textContent.trim()) {
        return this.$notify({
          group: "notification",
          text: "Provide value for field Resolution",
          type: "error",
        });
      }
      this.processing = true;
      this.edit.resolutionContent = linkifyPlainUrlsInHtml(
        this.edit.resolutionContent
      );
      try {
        await this.$http.put(`api/manageengine/EditTicket`, {
          resolution: this.edit.resolutionContent,
          manageengineID: this.ticket.manageengineID,
          displayID: this.ticket.displayID,
        });
        await this.$emit("updated");
        this.$notify({
          group: "notification",
          text: "Resolution updated successfully",
          type: "success",
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.processing = false;
        this.editMode = false;
      }
    },
    updateResolutionContent(v) {
      this.edit.resolutionContent = v.target.innerHTML;
    },
  },
};
</script>
<style></style>
